
import { Component, Prop, Vue } from "vue-property-decorator";
import PIcon from "@/components/look/PIcon.vue";

@Component({
  name: "p-modal",
  components: { PIcon },
  inheritAttrs: false,
})
/**
 *
 */
export default class PModal extends Vue {
  @Prop({ required: true, default: "Title of modal" })
  title!: string;
  @Prop({ required: false, default: "md" })
  size!: string;
  @Prop({ required: false, default: "p-modal-content" })
  classModalContent!: string;
  @Prop({ required: false, default: true })
  hideFooter!: boolean;
  @Prop({ required: true })
  modalId!: string;
  @Prop({ required: false, default: false })
  closeDisabled!: boolean;
  @Prop({ required: false, default: false })
  noCloseOnBackdrop!: boolean;
  @Prop({ required: false, default: "" })
  tooltipClose!: string;
}
